//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';
import constant from '~/const';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      locals: {
        OrderId: null,
        SumFrom: null,
        SumTo: null,
        TransferId: null,
        ReceiverAddress: null,
      },
      filters: {
        Status: null,
        OrderId: null,
        BaseCurrencyTitle: null,
        ReceiverAddress: null,
        TransferId: null,
        SumFrom: null,
        SumTo: null,
      },
      constant,
    };
  },

  computed: {
    ...mapState('cryptomatsTransactions', {
      filterLists: 'filters',
    }),
    ...mapState('tradersCurrencies', { currencies: 'data' }),

    getStatuses() {
      return [
        constant.cryptomats.STATUSES_LIST[2],
        constant.cryptomats.STATUSES_LIST[5],
      ];
    },

    getCryptoCurrencies() {
      return this.currencies.filter((item) => item.type === 0);
    },
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  created() {
    this.setFilters({});
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
    ]),
    ...mapActions('cryptomatsTransactions', [
      'setFilters',
    ]),

    handleLocalValue(key, value) {
      this.filters[key] = value;
    },
  },
};
